var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ch-container"},[_c('div',{staticClass:"logo-bar"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('logo-view')],1),_c('el-col',{attrs:{"span":12}},[_c('div',{staticStyle:{"text-align":"right"}},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.onLogin}},[_vm._v("登录")])],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }